// @format
import React from 'react';
import styled from 'styled-components';
import queryString from 'query-string';

const IFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  overflow: auto;
  border: none;
  padding: 0;
  margin: 0;
`;

export default ({ match }) => {
  const url = queryString.parse(window.location.search).url;
  console.log('Match', url);
  return <IFrame src={url} />;
};
